import { render } from "./_form-money.vue?vue&type=template&id=5d559740"
import script from "./_form-money.vue?vue&type=script&lang=js"
export * from "./_form-money.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__